// extracted by mini-css-extract-plugin
module.exports = {"but":"Journals_but__Oo1Oi","cont":"Journals_cont__1kpwP"};